import { ObjectValuesType } from "addiction-components";

export const OpenedMenuType = {
  MENU: 'MENU',
	FOLDER: 'FOLDER',
  FILTER: 'FILTER'
};
export type OpenedMenuType = ObjectValuesType<typeof OpenedMenuType>;
